import React, { Component } from 'react'
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { DropdownToggle } from "reactstrap"
import * as Icon from "react-feather"
//import Specific_Unpaid_Order_History_icon from '../../../assets/img/icons/saurbhi/Specific_Unpaid_Order_History_icon.png'
//import Specific_Unpaid_Order_History_White_icon from '../../../assets/img/icons/saurbhi/Specific_Unpaid_Order_History_White_icon.png'

class HeaderNewMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainMenuDisplay: false,
    }
  }
  mainMenuToggle = () => {
    this.setState((prevState) => ({
      mainMenuDisplay: !prevState.mainMenuDisplay,
    }));
  }
  render() {
    let currentPage = this.props.location.pathname.split('/')[3];
    return (
      <>
        <button className="btn mainMenuToggler mr-auto" onClick={this.mainMenuToggle}>
          <Icon.Menu />
        </button>
        <div
          className={"custom-navbar-overlay " + (this.state.mainMenuDisplay === true ? " d-block " : "d-none")}
          onClick={this.mainMenuToggle}
        ></div>
        <ul
          // className="nav navbar-nav buyer-menu pl-5 ml-3" 
          className={"custom-navbar nav navbar-nav buyer-menu mx-auto pl-xl-2 " + (this.state.mainMenuDisplay === true ? " show " : "")}
          id="main-menu-navigation"
        >
          <li className={"nav-item " + (currentPage === "place-order" ? "active" : "")}>
            <div className="nav-item-wrapper cursor-pointer single-item">
              <Link to={`${process.env.PUBLIC_URL}/order/place-order`}>
                <div onClick={this.mainMenuToggle}>
                  <DropdownToggle caret className="btn-primary">
                    <span className="menu-icon align-middle mr-75">
                      <Icon.ShoppingBag size={20} />
                    </span> <br className="d-none d-xl-block" />
                    <span className="menu-title align-middle">Place Order</span>
                  </DropdownToggle>
                </div>
              </Link>
            </div>
          </li>

          {/*  <li className={"nav-item " + (currentPage === "my-cart" ? "active" : "")}>
            <div className="nav-item-wrapper cursor-pointer single-item">
              <Link to={`${process.env.PUBLIC_URL}/buyer/my-cart`}>
                <div onClick={this.mainMenuToggle}>
                  <DropdownToggle caret className="btn-primary">
                    <span className="menu-icon align-middle mr-75">
                      <Icon.ShoppingCart size={22} />
                    </span> <br className="d-none d-xl-block" />
                    <span className="menu-title align-middle">My Cart</span>
                  </DropdownToggle>
                </div>
              </Link>
            </div>
          </li> */}

          <li className={"nav-item " + (currentPage === "buyer-order-history" ? "active" : "")}>
            <div className="nav-item-wrapper cursor-pointer single-item">
              <Link to={`${process.env.PUBLIC_URL}/order/buyer-order-history`}>
                <div onClick={this.mainMenuToggle}>
                  <DropdownToggle caret className="btn-primary">
                    <span className="menu-icon align-middle mr-75">
                      <Icon.FileText size={20} />
                    </span> <br className="d-none d-xl-block" />
                    <span className="menu-title align-middle">Order History</span>
                  </DropdownToggle>
                </div>
              </Link>
            </div>
          </li>

          {/* <li className={"nav-item " + (currentPage === "buyer-specific-order-history" ? "active" : "")}>
            <div className="nav-item-wrapper cursor-pointer single-item">
              <Link to={`${process.env.PUBLIC_URL}/order/buyer-specific-order-history`}>
                <div onClick={this.mainMenuToggle}>
                  <DropdownToggle caret className="btn-primary">
                    <span className="menu-icon align-middle mr-75">
                      <Icon.FileText size={20} />
                    </span> <br className="d-none d-xl-block" />
                    <span className="menu-title align-middle">Specific Order History</span>
                  </DropdownToggle>
                </div>
              </Link>
            </div>
          </li> */}
        </ul >
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    app: state.customizer
  }
}
export default connect(mapStateToProps)(withRouter(HeaderNewMenu))